module.exports = __webpack_public_path__ + "media/icons/offer-details-motocykle@2x-63146890.png";